const servicesFolder = [
  {
    value: 'seo',
    color: '#2A8AE0',
  },
  {
    value: 'content',
    color: '#556EE6',
  },
  {
    value: 'media',
    color: '#FA9D00',
  },
  {
    value: 'wa',
    color: '#34C38F',
  },
  {
    value: 'technology',
    color: '#13C2C2',
  },
];

export { servicesFolder };
